import { Checkbox, Switch } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { SwitchChangeEventHandler } from 'antd/es/switch';
import { EPermissionFeature, EPermissionRole, PermissionFeature, PermissionModule, PermissionRole } from 'components/Permission/interface';
import colorTheme from 'constants/color';
import settingServiceActions from 'features/settingService/services/actions';
import settingServiceSelectors from 'features/settingService/services/selectors';
import { IPermissionConfigFeature, IPermissionConfigRes } from 'features/settingService/services/types/permission';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';

interface VerifyPinRowProps {
  record: IPermissionConfigRes,
}

const VerifyPinRow = ({record}: VerifyPinRowProps) => {

  const dispatch = useAppDispatch();
  const dataChanged = settingServiceSelectors.getPermissionConfigChanged();
  const dataFiltered = settingServiceSelectors.getPermissionConfigFiltered();

  const getDataChange = (
      data: IPermissionConfigRes[] | null,
      module: PermissionModule,
      feature: PermissionFeature,
      checked: boolean
    ): IPermissionConfigRes[] => {
      return (data ?? []).map((permission) => {
        if(permission.moduleCode === module) {
          return {
            ...permission,
             features: permission.features.map(feat => {

              if(feat.featureCode === feature) {
                return {
                  ...feat,
                  requirePin: checked
                } as IPermissionConfigFeature;
              }
              return feat;
            })
          };
        }
        return permission;
      });
    };

  const handleCheckboxChange = (
    module: PermissionModule,
    feature: PermissionFeature,
    checked: boolean
  ) => {
      dispatch(settingServiceActions.updatePermissionConfigChanged(getDataChange(dataChanged, module, feature, checked)));
      dispatch(settingServiceActions.updatePermissionConfigFiltered(getDataChange(dataFiltered, module, feature, checked)));
  };
    
  return (
    <PermissionWrapper>
      {record.features.map(feature => (
        <div key={feature.featureCode}>
          <StyledSwitch
            checkedChildren="ON"
            unCheckedChildren="OFF"
            checked={feature?.requirePin}
            onChange={(checked: boolean) =>
              handleCheckboxChange(
                record.moduleCode,
                feature.featureCode,
                checked
              )
            }
          />
        </div>
        ))}
    </PermissionWrapper>
  );
};

export default VerifyPinRow;

const PermissionWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  & > div {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${colorTheme['v2_border_2']};
    padding-left: 30px;
    &:last-child {
      border-bottom: none;
    }
  }
`;

const StyledSwitch = styled(Switch)`

`;